import './DifficultySelect.css';
import { DIFFICULTY } from '../../constants/difficulty';

const levels = [
  {
    id: DIFFICULTY.BASIC,
    label: 'Basis',
    icon: '🟢',
    description: 'Einsteiger-Level mit klar erkennbaren Phishing-Merkmalen. Ideal zum Einstieg.',
    requiredPoints: 0,
  },
  {
    id: DIFFICULTY.FORTGESCHRITTEN,
    label: 'Fortgeschritten',
    icon: '🟡',
    description: 'Täuschend echte Mails mit subtileren Hinweisen. Für geübte Nutzer.',
    requiredPoints: 500,
  },
  {
    id: DIFFICULTY.EXPERTE,
    label: 'Experte',
    icon: '🔴',
    description: 'Hochkomplexe Angriffe mit mehreren Fehlerstellen. Nur für Profis.',
    requiredPoints: 1000,
  },
];

function DifficultySelect({ player, onSelect }) {
  return (
    <div className="difficulty-select">
      <h2>Schwierigkeitsgrad wählen</h2>
      <p className="difficulty-subtitle">
        Wähle deinen Level gesperrte Stufen werden mit mehr Punkten freigeschaltet.
      </p>

      <div className="difficulty-cards">
        {levels.map((level) => {
          const isUnlocked = player.total_points >= level.requiredPoints;
          return (
            <div
              key={level.id}
              className={`difficulty-card ${isUnlocked ? 'unlocked' : 'locked'}`}
              onClick={() => isUnlocked && onSelect(level.id)}
            >
              <div className="difficulty-card-header">
                <span className="difficulty-icon">{level.icon}</span>
                <span className="difficulty-label">{level.label}</span>
                {!isUnlocked && (
                  <span className="difficulty-lock">🔒 ab {level.requiredPoints} Punkten</span>
                )}
              </div>
              <p className="difficulty-description">{level.description}</p>
              {isUnlocked && (
                <button className="difficulty-btn">Auswählen →</button>
              )}
            </div>
          );
        })}
      </div>

      <p className="difficulty-points">
        Deine Punkte: <strong>{player.total_points}</strong> | Level: <strong>{player.current_level}</strong>
      </p>
    </div>
  );
}

export default DifficultySelect;